import { render, staticRenderFns } from "./ProductDetailDesc.vue?vue&type=template&id=286b3d0e&scoped=true&"
import script from "./ProductDetailDesc.vue?vue&type=script&lang=js&"
export * from "./ProductDetailDesc.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailDesc.vue?vue&type=style&index=0&id=286b3d0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286b3d0e",
  null
  
)

export default component.exports